module.exports = __webpack_public_path__ + "a8a10a3e/img/upload-icon.9179ae4e.svg";